// House of Lili 送料無料進捗バー
// テーマのカート更新イベント（cart:update, assets/events.js 参照）を受けて /cart.js を再取得する。
class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.textEl = this.querySelector('[data-fsb-text]');
    this.fillEl = this.querySelector('[data-fsb-fill]');
    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.render(parseInt(this.dataset.cartTotal, 10) || 0);

    this.onCartUpdate = () => this.refresh();
    document.addEventListener('cart:update', this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.onCartUpdate);
  }

  async refresh() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(`${root}cart.js`);
      if (!res.ok) return;
      const cart = await res.json();
      this.render(cart.total_price);
    } catch {
      // ネットワークエラー時は表示を維持する
    }
  }

  render(cartTotal) {
    if (!this.textEl || this.threshold <= 0) return;
    const remaining = this.threshold - cartTotal;
    if (remaining <= 0) {
      this.textEl.textContent = '送料無料でお届けします';
    } else {
      const yen = Math.ceil(remaining / 100);
      this.textEl.textContent = `あと ¥${yen.toLocaleString('ja-JP')} で送料無料になります`;
    }
    if (this.fillEl) {
      const pct = Math.max(0, Math.min(100, (cartTotal / this.threshold) * 100));
      this.fillEl.style.width = `${pct}%`;
    }
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
